import React from 'react'

import Paper from '@material-ui/core/Paper'
import Text from '@material-ui/core/Typography'

function Add() {
	return (
		<Paper style={{ padding: 20, minHeight:800 }} >
			<Text variant='h5' gutterBottom>
				Add
			</Text>
			<Text variant='caption' gutterBottom>
				Add
			</Text>
		</Paper>
	)
}
export default Add
